module.exports = __webpack_public_path__ + "static/media/twitter.3ce3dcb0.svg";